<a
    class="genesys-g"
    [href]="genesysUrl"
    target="_blank"
    matTooltip="Visit Genesys"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    aria-label="Visit Genesys">
    <mat-icon [svgIcon]="'genesys_g'" aria-hidden></mat-icon>
</a>
<span class="copyright">
    Copyright &copy; {{ currentYear }}
    <a
        class="genesys-text"
        [href]="genesysUrl"
        target="_blank"
        matTooltip="Visit Genesys"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000">
        Genesys
    </a>
    <span *appDesktop>. All rights reserved.</span>
</span>
<span *appMobile>All rights reserved.</span>
<span class="links">
    <a
        *ngIf="termsOfUse$ | async as termsOfUse"
        [href]="termsOfUse.url"
        target="_blank"
        matTooltip="Visit Terms of Use"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000"
        data-testId="terms-of-use">
        {{ termsOfUse.label }}
    </a>
    <a
        *ngIf="privacyPolicy$ | async as privacyPolicy"
        [href]="privacyPolicy.url"
        target="_blank"
        matTooltip="Visit Privacy Policy"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000"
        data-testId="privacy-policy">
        {{ privacyPolicy.label }}
    </a>
</span>
<app-cookie-consent></app-cookie-consent>
<!-- Feedback is now handled by the Qualtrics feedback button provided via the qualtrics-feedback-survey injector -->
<!-- <button
    (click)="handleFeedbackFormDialog()"
    [matTooltip]="'Send us feedback'"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000">
    Send us feedback
    <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
</button> -->
